export class SttAPI {
  static get baseUrl() {
    return process.env.NODE_ENV === "development"
      ? process.env.REACT_APP_API_BASE_URL
      : process.env.REACT_APP_API_BASE_URL;
  }
  static speechToTextByWav() {
    return {
      method: "POST",
      url: this.baseUrl + "/stt/from_wav",
    };
  }
}
